import { NavLink, Outlet } from 'react-router-dom';
import { session } from '../../lib/api';

const NAV = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/products', label: 'Products' },
  { to: '/admin/stock', label: 'Stock adjust', scope: 'inventory.adjust' },
  { to: '/admin/import', label: 'Import / export', scope: 'product.import' },
  { to: '/admin/staff', label: 'Staff & PINs', scope: 'staff.manage' },
  { to: '/admin/terminals', label: 'Terminals & payments', scope: 'terminal.manage' },
  { to: '/admin/exceptions', label: 'Refund exceptions' },
  { to: '/admin/data-quality', label: 'Data quality', scope: 'report.group' },
];

export default function AdminLayout() {
  const s = session.get()!;
  const visible = NAV.filter((n) => !n.scope || s.user.scopes.includes(n.scope));

  return (
    <div className="flex h-[calc(100vh-49px)]">
      <aside className="w-56 shrink-0 border-r border-gray-800 bg-gray-900/40 p-3">
        <div className="text-xs uppercase tracking-wide text-gray-500 px-2 mb-2">Back office</div>
        <nav className="space-y-0.5">
          {visible.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) =>
                `block px-3 py-2 rounded-lg text-sm ${
                  isActive ? 'bg-brand text-white' : 'text-gray-300 hover:bg-gray-800'
                }`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex-1 min-w-0 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
